module.exports = " <div :class=\"['modal', 'animated', visible ? 'is-active' : '']\" :transition=transition transition-mode=in-out> <div class=modal-background @click=close></div> <div class=modal-container> <div class=modal-content> <slot></slot> </div> </div> <button class=modal-close @click=close v-if=closable></button> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-bulma-modal/src/Modal.vue
// module id = 925
// module chunks = 2